export const PLACEHOLDER = 'Search your fund';
export const HEADER_TEXT = 'Discover 600+ Mutual Funds, 100+ AMC, etc';
export const ON_NO_RESULT_FOUND = 'No Results Found';
export const NAME = 'search-bar';
export const PLEASE_ENTER_CORRECT_SCHEME_NAME = 'Please enter correct scheme name';
